// Two-line labels for the category buttons in the header (small line on top, main word below).
export default {
  rail: {
    categories: {
      all: { top: "All", bottom: "Tours" },
      escunas: { top: "Schooner", bottom: "Tours" },
      privadas: { top: "Private Boats &", bottom: "Schooners" },
      compartilhadas: { top: "Shared", bottom: "Boats" },
      jeep: { top: "Jeep", bottom: "Tours" },
      bolivia: { top: "Bolivia", bottom: "Expedition" },
    },
  },
};
